import { withMVC } from '@tcp-base/design-system';
import { useUserPanelController } from './UserPanel.controller';
import { UserPanelViewer } from './UserPanel.viewer';
import { UserPanelModel } from './UserPanel.model';

export const UserPanel = withMVC<Record<string, never>, UserPanelModel>({
  useController: useUserPanelController,
  Viewer: UserPanelViewer,
});
